module.exports = __webpack_public_path__ + "561cf9bf169d57925d52345ad96e1fc4.jpg";